import axios from "axios";
import apiUrlconops from "./configconops"

const apiClientconops = axios.create({
  baseURL: apiUrlconops,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to every request
apiClientconops.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("access_token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClientconops;


